import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { FiCheck } from 'react-icons/fi';
import { SectionHeading } from '../ui/SectionHeading';

export const WhatsIncluded = () => {
  const items = [
    "30+ Premium Courses",
    "Niche Clarity Blueprint",
    "Offer Creation System",
    "Funnel Building System",
    "Ads Mastery",
    "Social Media Growth",
    "Sales Automation",
    "Upsell System"
  ];

  return (
    <section className="py-24 px-4 bg-[#0B0E14]">
      <div className="max-w-5xl mx-auto">
        <div className="bg-gradient-to-b from-navy-800 to-navy-900 border border-white/10 rounded-3xl p-8 md:p-12 shadow-2xl">
          <SectionHeading>What's Included in Silver 2.0</SectionHeading>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mt-12">
            {items.map((item, idx) => (
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.05 }}
                key={idx}
                className="flex items-center gap-4 bg-white/5 rounded-xl p-4 border border-white/5 hover:bg-white/10 transition-colors"
              >
                <div className="w-8 h-8 rounded-full bg-gold-500/20 text-gold-400 flex items-center justify-center shrink-0">
                  <SafeIcon icon={FiCheck} className="text-lg" />
                </div>
                <span className="text-lg text-white font-medium">{item}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};